import image from '../assets/nature.png'
import writterImage from '../assets/Writter-image.png'
import catigorie1 from '../assets/categorie1.png'
import catigorie2 from '../assets/categorie2.png'
import catigorie3 from '../assets/categorie3.png'
import catigorie4 from '../assets/categorie4.png'
import catigorie5 from '../assets/categorie5.png'
import catigorie6 from '../assets/categorie6.png'
import { v4 as uuidv4 } from 'uuid';

export const CategoriesScrollData = [

    {
        id:"1",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id:"2",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id:"3",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id:"4",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {   
        id:"5",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id:"6",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id:"7",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id:"8",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id:"9",
        image:image,
        duration:'10 Min',
        title:'Tree Thinks',
        description:'Discover the cutting-edge technologies that are reshaping homes. From smart appliancesto integrated systems, find the perfect tech solutions at StuffUs.',
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    }

]

export const CategoriesScrollData_Desktop = [
    {
        id: uuidv4(),
        image: catigorie1,
        title: "Transform Your Space with Stylish Home Decor",
        description: "Discover the cutting-edge technologies that are reshaping homes.",
        duration: "9 Min",
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id: uuidv4(),
        image: catigorie2,
        title: "Empowering Learning: Explore Educational Essentials",
        description: "Discover the cutting-edge technologies that are reshaping homes.",
        duration: "9 Min",
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id: uuidv4(),
        image: catigorie3,
        title: "Trendy and Timeless Clothing for Everyone",
        description: "Discover the cutting-edge technologies that are reshaping homes.",
        duration: "9 Min",
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id: uuidv4(),
        image: catigorie4,
        title: "Smart Banking Solutions for Your Future",
        description: "Discover the cutting-edge technologies that are reshaping homes.",
        duration: "9 Min",
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id: uuidv4(),
        image: catigorie5,
        title: "Live Well with Our Healthcare Solutions",
        description: "Discover the cutting-edge technologies that are reshaping homes.",
        duration: "9 Min",
        writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    },
    {
        id: uuidv4(),
        image: catigorie6,
        title: "Fashion That Speaks to Your Personality",
        description: "Discover the cutting-edge technologies that are reshaping homes.",
        duration: "9 Min",
         writter:{
            wirtter_image:writterImage,
            wiritter_name:'Arience McCoy'
        }
    }
]

